import React, { useEffect, useState } from "react";
import { CommonService } from "../../services/CommonService";
import { useLocalStorage } from "../../auth/useLocalStorage";
import { TableContainer, Paper, Button, IconButton, Typography, Table, TableHead, TableBody, TableCell, TableRow } from "@mui/material";
import moment from "moment";
import { ISale, ISaleDetail } from "../../common/interfaces";
import VisibilityIcon from '@mui/icons-material/Visibility';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import { PayOrder } from "../payOrder";
export const ScheduleOrders: React.FC = () => {
  const [user, ] = useLocalStorage("user", null);
  const [rows, setRows] = useState([])
  const [view, setView] = useState('list')
  const [sale, setSale] = useState<ISale>()
  const [selectedSale, setSelectedSale] = useState(0)
  const warehouseId = user?.warehouse_id

  const mapPaymentsMethods = {
    cash: "Efectivo",
    credit_card: "Tarjeta de Crédito",
    debit_card: "Tarjeta de Débito",
    gift_card: "Tarjeta de Regalo",
    vales: "Vales de despensa",
    usd: "Dólares",
    other: "Otros",
    transfer: "Transferencia",
    credit: "Crédito",
  };

  const shippedTypeMap: Record<string, string> = {
    shipped: "A Domicilio",
    onSite: "Recoger en Tienda",
    inRoom: "Comedor",
  };

  // Función para calcular la hora de envío (hora de entrega - 30 minutos)
  // Solo aplica para pedidos a domicilio
  const calculateSendTime = (deliveryTime: string, shippedType: string) => {
    if (shippedType === 'shipped') {
      return moment(deliveryTime).subtract(30, 'minutes').format("hh:mm a");
    }
    return '-';
  };

  // Función para calcular el total de anticipos
  const calculateTotalAnticipos = (payments: any[]) => {
    if (!payments || payments.length === 0) return 0;
    // Filtrar solo los anticipos (is_anticipo === 1)
    return payments
      .filter((payment: any) => payment.is_anticipo === 1)
      .reduce((acc, payment) => acc + parseFloat(String(payment.amount || "0")), 0);
  };

  // Hay caja abierta para poder cobrar (la caja vive en user.cbox).
  const cashOpen = !!(user?.cashOpen && user?.cbox?.id);

  const loadOrders = () => {
    CommonService.getScheduleOrders(warehouseId).then((response: any) => {
      console.log("Schedule Orders", response)
      if(response.success){
        setRows(response.object)
      }
    })
  };

  useEffect(() => {
    loadOrders();
  }, [])
  useEffect(() => {
    if(view === 'detail'){
      if(selectedSale > 0){
        CommonService.getSaleInfo(selectedSale).then((response: any) => {
          console.log("Ticket Order Information", response)
          if(response.success){
            setSale(response.object)
          }
        })
      }
    }
  }, [view])
  const viewItem = (item: any) => {
    setSelectedSale(item.order.id)
    setView('detail')
  }
  const payItem = (item: any) => {
    setSelectedSale(item.order.id)
    setView('pay')
  }
  // Saldo pendiente de un pedido = total - anticipos ya cobrados.
  const pendingBalance = (row: any) => {
    const total = parseFloat(String(row.order?.total || "0"));
    const anticipos = row.order?.anticipo_sum !== undefined
      ? parseFloat(String(row.order.anticipo_sum || "0"))
      : calculateTotalAnticipos(row.order?.payments);
    return parseFloat((total - anticipos).toFixed(2));
  };
  // Calcular estadísticas de pedidos
  const todayOrders = rows.filter((row: any) => moment(row.schedule_data).isSame(moment(), 'day'));
  const futureOrders = rows.filter((row: any) => moment(row.schedule_data).isAfter(moment(), 'day'));

  return (
    <div>
      {
        view === 'list' && (
          <>
            {/* Header con título y estadísticas */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
              <Typography variant="h6" style={{ margin: 0 }}>
                 
              </Typography>

              {/* Estadísticas compactas */}
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <div style={{
                  padding: '5px 12px',
                  backgroundColor: '#1a3a1a',
                  borderRadius: '5px',
                  border: '1px solid #4caf50',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <Typography variant="caption" style={{ color: '#4caf50', fontWeight: 'bold', fontSize: '11px' }}>
                    🔥 HOY
                  </Typography>
                  <Typography variant="h6" style={{ color: '#4caf50', margin: 0, fontSize: '18px' }}>
                    {todayOrders.length}
                  </Typography>
                </div>

                <div style={{
                  padding: '5px 12px',
                  backgroundColor: '#3a2a1a',
                  borderRadius: '5px',
                  border: '1px solid #ff6f00',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <Typography variant="caption" style={{ color: '#ff6f00', fontWeight: 'bold', fontSize: '11px' }}>
                    📆 PRÓXIMOS
                  </Typography>
                  <Typography variant="h6" style={{ color: '#ff6f00', margin: 0, fontSize: '18px' }}>
                    {futureOrders.length}
                  </Typography>
                </div>

                <div style={{
                  padding: '5px 12px',
                  backgroundColor: '#2a2a3a',
                  borderRadius: '5px',
                  border: '1px solid #2196f3',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <Typography variant="caption" style={{ color: '#2196f3', fontWeight: 'bold', fontSize: '11px' }}>
                    📊 TOTAL
                  </Typography>
                  <Typography variant="h6" style={{ color: '#2196f3', margin: 0, fontSize: '18px' }}>
                    {rows.length}
                  </Typography>
                </div>
              </div>
            </div>

            <TableContainer component={Paper}>
            <table
              style={{
                width: "100%",
                fontSize: "14px",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{ width: "7%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    ID Venta
                  </th>
                  <th
                    style={{ width: "10%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Fecha de Registro
                  </th>
                  <th
                    style={{ width: "10%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Usuario
                  </th>
                  <th
                    style={{ width: "12%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Cliente
                  </th>
                  <th
                    style={{ width: "9%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Tel.
                  </th>
                  <th
                    style={{ width: "7%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Anticipo
                  </th>
                  <th
                    style={{ width: "7%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Monto
                  </th>
                  <th
                    style={{ width: "10%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Fecha de Entrega
                  </th>
                  <th
                    style={{ width: "10%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Entrega
                  </th>
                  <th
                    style={{ width: "9%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Hora de Envío
                  </th>
                  <th
                    style={{ width: "9%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Hora de Entrega
                  </th>
                  <th
                    style={{ width: "5%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row: any) => {
                  // Usar anticipo_sum del backend si está disponible, sino calcular
                  const totalAnticipos = row.order?.anticipo_sum !== undefined
                    ? parseFloat(String(row.order.anticipo_sum || "0"))
                    : calculateTotalAnticipos(row.order?.payments);

                  // Verificar si es pedido de hoy
                  const isToday = moment(row.schedule_data).isSame(moment(), 'day');
                  const rowStyle = isToday ? { backgroundColor: '#1a3a1a' } : {};

                  console.log('Row data:', {
                    orderId: row.order?.id,
                    scheduleData: row.schedule_data,
                    anticipoSum: row.order?.anticipo_sum,
                    totalAnticipos,
                    isToday
                  });

                  return row.order ? (
                    <tr key={row.id} style={rowStyle}>
                      <td align="center">
                        {row.order.id ? `S-${row.order.id}` : ''}
                      </td>
                      <td align="center">{moment(row.order.created_at).format("DD/MM/YYYY HH:mm")}</td>
                      <td align="center">{row.order.usuario?.nombre || '-'}</td>
                      <td align="center">{row.order.cliente?.nombre || '-'}</td>
                      <td align="center">{row.order.cliente?.telefono || '-'}</td>
                      <td align="center">${totalAnticipos.toFixed(2)}</td>
                      <td align="center">${parseFloat(row.order.total || 0).toFixed(2)}</td>
                      <td align="center">
                        {isToday ? (
                          <strong style={{ color: '#4caf50' }}>HOY</strong>
                        ) : (
                          moment(row.schedule_data).format("DD/MM/YYYY")
                        )}
                      </td>
                      <td align="center">{shippedTypeMap[row.order.shipped_type] || row.order.shipped_type || '-'}</td>
                      <td align="center">{calculateSendTime(row.schedule_data, row.order.shipped_type)}</td>
                      <td align="center">
                        <strong style={{ color: isToday ? '#4caf50' : '#ff6f00', fontSize: '15px' }}>
                          {moment(row.schedule_data).format("hh:mm A")}
                        </strong>
                      </td>
                      <td align="center">
                        <IconButton
                          aria-label="view"
                          onClick={() => viewItem(row)}
                          size="small"
                        >
                          <VisibilityIcon />
                        </IconButton>
                        {(() => {
                          const saldo = pendingBalance(row);
                          if (saldo <= 0) {
                            return (
                              <Typography variant="caption" style={{ color: '#4caf50', display: 'block' }}>
                                Pagado
                              </Typography>
                            );
                          }
                          return (
                            <IconButton
                              aria-label="cobrar"
                              title={cashOpen ? `Cobrar (saldo $${saldo.toFixed(2)})` : "Abre una caja para cobrar"}
                              onClick={() => payItem(row)}
                              disabled={!cashOpen}
                              size="small"
                            >
                              <PointOfSaleIcon style={{ color: cashOpen ? '#4caf50' : '#777' }} />
                            </IconButton>
                          );
                        })()}
                      </td>
                    </tr>
                  ) : null;
                })}
                {/* {rows.map((row: any) => (
                  <tr key={row.id}>
                    <td align="center">{row.id}</td>
                    <td align="center">{row.client_name}</td>
                    <td align="center">{row.total_amount}</td>
                    <td align="center">{moment(row.date).format("DD/MM/YYYY")}</td>
                    <td align="center">{moment(row.date).format("HH:mm")}</td>
                  </tr>
                ))} */}
              </tbody>
            </table>
          </TableContainer>
          </>
        )
      }
      {
        view === 'pay' && selectedSale > 0 && (
          <div>
            <Button onClick={() => setView('list')} style={{ marginBottom: 8 }}>Volver</Button>
            <PayOrder
              saleId={selectedSale}
              advance
              handleCancel={() => setView('list')}
              closeModal={() => { loadOrders(); setView('list'); }}
              openTicket={() => { loadOrders(); setView('list'); }}
            />
          </div>
        )
      }
      {
        view === 'detail' && (
          <div>
            <Typography style={{ fontSize: "18px" }}>Pedido: { sale?.id }</Typography>
            <Typography style={{ fontSize: "18px" }}>Cliente: { sale?.cliente?.nombre }</Typography>
            <Typography style={{ fontSize: "18px" }}>Teléfono: { sale?.cliente?.telefono }</Typography>
            <Typography style={{ fontSize: "18px" }}>Monto: $ { sale?.total }</Typography>
            <Typography style={{ fontSize: "18px" }}>Fecha y Hora de Registro: { moment(sale?.created_at).format("DD/MM/YYYY  HH:mm a") }</Typography>
            <Typography style={{ fontSize: "18px" }}>Fecha y Hora de Entrega: { moment(sale?.schedule).format("DD/MM/YYYY HH:mm a") }</Typography>
            <br />

            {/* Sección para mostrar anticipos */}
            <div>
              <Typography variant="h6">Anticipos:</Typography>
              {sale?.payments && sale.payments.filter((p: any) => p.is_anticipo === 1).length > 0 ? (
                <TableContainer component={Paper} style={{ maxHeight: "200px", overflowY: "auto" }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Fecha y Hora</TableCell>
                        <TableCell>Método de Pago</TableCell>
                        <TableCell>Monto</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sale.payments
                        .filter((payment: any) => payment.is_anticipo === 1)
                        .map((payment, index) => (
                          <TableRow key={index}>
                            <TableCell>{moment(payment.created_at).format("DD/MM/YYYY h:mm A")}</TableCell>
                            <TableCell>{mapPaymentsMethods[payment.payment_method]}</TableCell>
                            <TableCell>$ {parseFloat(String(payment.amount || "0")).toFixed(2)}</TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                    <tfoot>
                      <TableRow>
                        <TableCell colSpan={2} style={{ textAlign: "right", fontWeight: "bold" }}>
                          Total de Anticipos:
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          $ {sale.payments
                            .filter((p: any) => p.is_anticipo === 1)
                            .reduce((acc, payment) => acc + parseFloat(String(payment.amount || "0")), 0)
                            .toFixed(2)}
                        </TableCell>
                      </TableRow>
                    </tfoot>
                  </Table>
                </TableContainer>
              ) : (
                <Typography>No hay anticipos registrados.</Typography>
              )}
            </div>

            <br />

            <Typography style={{ fontSize: "18px" }}>Detalles de Productos:</Typography>
            <TableContainer component={Paper}>
            <table style={{
                width: "100%",
                fontSize: "14px",
                borderCollapse: "collapse",
              }}>
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Cantidad</th>
                  <th>Precio</th>
                  <th>Iva</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                { sale?.detalles.map((detail: ISaleDetail) => (
                  <tr key={detail.id}>
                    <td>{ detail.producto.name }</td>
                    <td>{ detail.cantidad }</td>
                    <td>{ detail.precio }</td>
                    <td>{ detail.iva }</td>
                    <td>{ detail.total }</td>

                  </tr>
                )) }
                </tbody>
            </table>
            </TableContainer>
            <br />
            <br />
            <Button onClick={() => setView('list')}>Volver</Button>
          </div>
        )
      }
    </div>
  );
}